@if (itemsSource) {
  <app-paged-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [itemsSource]="itemsSource"
    [totalCount]="totalResults"
    (onPageChange)="pagingChanged($event)"
    (onSortChange)="sortChanged($event)"
    (onColumnChange)="onColumnChange($event)"
    (onSelectedIdsChange)="onSelectedIdsChange($event)"
    (onDeselectedIdsChange)="onDeselectedIdsChange($event)"
    (onAffectedItemsCountChange)="onAffectedItemsCountChange($event)"
    (onAllSelectedChange)="onAllSelectedChange($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    [preferencesKey]="'rentinvoicingorder.list'"
    >
  </app-paged-list-view>
}
